<template>
  <ul ref="tabsContainer" class="tabs" :class="{ 'header-fixed': isHeaderFixed }">
    <li
      v-for="(tab, index) in dynamicTabs"
      :key="index"
      ref="tabItems"
      :class="{ 'active': isActive(tab.path) }"
      @click="goTo(tab.path)"
    >
      <a>{{ $t(tab.label) }}</a>
    </li>
  </ul>
</template>
<script>
export default {
  data() {
    return {
      isHeaderFixed: false
    }
  },
  computed: {
    dynamicTabs() {
      const baseTabs = [
        { path: '/points/all-bonus', label: 'Bao.vip_type' },
        { path: '/points/coupon', label: 'Bao.coupon' }
      ]

      return baseTabs
    }
  },
  watch: {
    '$route'() {
      this.$nextTick(() => {
        this.centerActiveTab()
      })
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.$nextTick(() => {
      this.centerActiveTab()
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.isHeaderFixed = window.scrollY >= 70
    },
    goTo(path) {
      this.$router.push(path)
    },
    isActive(path) {
      return this.$route.path === path
    },
    centerActiveTab() {
      const activeTabIndex = this.dynamicTabs.findIndex(tab => this.isActive(tab.path))
      if (activeTabIndex !== -1) {
        const activeTab = this.$refs.tabItems[activeTabIndex]
        if (activeTab) {
          const container = this.$refs.tabsContainer
          const containerWidth = container.offsetWidth
          const tabWidth = activeTab.offsetWidth
          const tabLeft = activeTab.offsetLeft
          const scrollLeft = tabLeft - (containerWidth / 2) + (tabWidth / 2)
          container.scrollLeft = scrollLeft
        }
      }
    }
  }
}
</script>
